<template>
  <div class="floating-contact" :class="{ 'is-hidden': contactInView }">
    <a class="floating-contact__call" :href="telHref" aria-label="Call us">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
        />
      </svg>
    </a>
    <a
      class="floating-contact__main"
      :href="'#' + contactId"
      @click.prevent="onLinkClick('#' + contactId)"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.75 5.25L3 6V18L3.75 18.75H20.25L21 18V6L20.25 5.25H3.75ZM4.5 7.6955V17.25H19.5V7.69525L11.9999 14.5136L4.5 7.6955ZM18.3099 6.75H5.68986L11.9999 12.4864L18.3099 6.75Z"
        />
      </svg>
      <span>Contact us</span>
    </a>
  </div>
</template>

<script>
import shared from "../shared";

export default {
  props: {
    contactId: String,
    phone: String,
  },
  data() {
    return {
      contactInView: false,
      observer: null,
    };
  },
  computed: {
    telHref() {
      return "tel:" + this.phone.replace(/\s+/g, "");
    },
  },
  mounted() {
    const contact = document.getElementById(this.contactId);
    if (!contact) return;
    this.observer = new IntersectionObserver(([entry]) => {
      this.contactInView = entry.isIntersecting;
    });
    this.observer.observe(contact);
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    onLinkClick(link) {
      shared.onLinkClick(link);
    },
  },
};
</script>

<style lang="scss">
@import "./../../variables.scss";

.floating-contact {
  position: fixed;
  right: $space-4;
  bottom: calc(#{$space-4} + env(safe-area-inset-bottom, 0px));
  z-index: 999;
  display: flex;
  align-items: center;
  gap: $space-3;
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s;

  &.is-hidden {
    opacity: 0;
    transform: translateY($space-2);
    visibility: hidden;
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s 0.2s;
  }

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    border-radius: 999px;
    text-decoration: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: opacity 0.15s ease;

    &:hover {
      opacity: 0.85;
    }
  }

  svg {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }

  &__call {
    width: 48px;
    background-color: $primary;
    color: $secondary;
  }

  &__main {
    gap: $space-2;
    padding: 0 $space-6 0 $space-4;
    background-color: $secondary;
    color: $third;
    font-family: fontSans_b;
    font-size: $medium;
  }
}

// The header shows a "Contact Us" button above this width
@media (min-width: 1001px) {
  .floating-contact {
    display: none;
  }
}
</style>
